var render, staticRenderFns
import script from "./role_manage.vue?vue&type=script&lang=js"
export * from "./role_manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d94f0c7')) {
      api.createRecord('4d94f0c7', component.options)
    } else {
      api.reload('4d94f0c7', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/role_manage/role_manage.vue"
export default component.exports